import React from "react";
import Common_title from "../../common-components/common_title/Common_title";
import "./About_Shore.css";

const About_Shore = () => {
  return (
    <section className="aboutus_shore_section">
      <div className="container">
        <div className="section_holder">
          <div className="row">
            {/* LEFT CONTENT */}
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="about_shore_title_holder">
                <Common_title text="⚓ ABOUT SHORE CLINIC" />
              </div>

              <div className="about_shore_content_holder">
                <p className="about_shore_content">
                  Founded in 2018, <b>Shore Clinic</b> is a <b>DG Shipping-approved</b> and <b>ISO-certified</b> marine medical centre in <b>Kothrud, Pune.</b>We specialize in <b>Pre-Employment, Periodic, Pre-Sea, and Post Signed-Off medicals</b> for seafarers and shipping personnel.
                </p>
                <p className="about_shore_content">
                  Our clinic is <b>centrally located, fully equipped,</b> and committed to providing <b>fast, accurate, and compliant fitness certifications</b>. With years of experience, we prioritize <b>health, safety, and peace of mind</b> for the seafaring community.
                </p>

                <div className="blue_div_holder">
                  <p className="blue_div_text">
                    <b>“A healthy Crew is the Anchor of a Safe voyage — We ensure
                      you Stay fit to sail.”</b>
                    <br></br>
                    -Dr. Pradnya Vinod Gawande, DG
                    Approved Medical Examiner
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="about_shore_image_holder">
                <img
                  src="/assets/images/about_us/about_shore_img.png"
                  alt="shore-img"
                  className="shore_img"
                />
              </div>
            </div>
          </div>

          {/* ----------- THREE BOXES SECTION ----------- */}
          <div className="row g-4 about_boxes_row mt-3 ">
            <div className="col-lg-3 col-md-6 col-sm-6 ">
              <div className="about_box">
                <h4 className="about_box_title">Our Vision</h4>
                <p className="about_box_text">
                  To be India's most trusted marine medical centre, delivering
                  excellence in healthcare, compliance, and crew wellness.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="about_box">
                <h4 className="about_box_title">Our Mission</h4>
                <p className="about_box_text">
                  To ensure seafarers are medically fit through ethical,
                  accurate, and compliant assessments while providing
                  personalized guidance and preventive care.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="about_box">
                <h4 className="about_box_title">Our Values</h4>
                <p className="about_box_text">
                  <ul className="about_values_list">
                    <li>Integrity</li>
                    <li>Accuracy</li>
                    <li>Compassion</li>
                    <li>Compliance</li>
                    <li>Commitment</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About_Shore;
